import { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Home, Store, Package, ShoppingBag, User } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import { supabase } from '@/integrations/supabase/client';

type Tab = { to: string; label: string; icon: React.ElementType; match?: (p: string) => boolean };

export function MobileBottomNav() {
  const { pathname } = useLocation();
  const { session } = useAuth();
  const [isSeller, setIsSeller] = useState(false);

  useEffect(() => {
    if (!session?.user?.id) { setIsSeller(false); return; }
    supabase.from('seller_profiles').select('is_active').eq('user_id', session.user.id).maybeSingle()
      .then(({ data }) => setIsSeller(!!data?.is_active));
  }, [session?.user?.id]);

  const tabs: Tab[] = [
    { to: '/dashboard', label: 'Home', icon: Home, match: (p) => p === '/dashboard' },
    { to: '/settings/basket', label: 'Basket', icon: Store, match: (p) => p.startsWith('/settings/basket') },
    { to: '/orders', label: 'My Orders', icon: Package, match: (p) => p.startsWith('/orders') || p.startsWith('/my-orders') },
    { to: '/settings/profile', label: 'Profile', icon: User, match: (p) => p.startsWith('/settings') && !p.startsWith('/settings/basket') },
  ];

  return (
    <nav
      className="fixed bottom-0 inset-x-0 z-30 bg-card border-t border-border md:hidden"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      <ul className="flex items-stretch justify-around">
        {tabs.map((t) => {
          const active = t.match ? t.match(pathname) : pathname === t.to;
          const Icon = t.icon;
          return (
            <li key={t.label} className="flex-1">
              <NavLink
                to={t.to}
                className={`flex flex-col items-center justify-center gap-0.5 py-2 text-[10px] font-medium ${active ? 'text-primary' : 'text-muted-foreground'}`}
              >
                <Icon className={`h-5 w-5 ${active ? 'text-primary' : ''}`} />
                <span>{t.label}</span>
              </NavLink>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
